import type { sessionSummaryTimesConfig } from "@expert/app-config/types";
import { addSessionSummaryMessage } from "@soluto-private/expert-workspace-timeline";
import { useVerifiedCustomerStore } from "@/customer-info";
import { useSessionSummaryStore } from "../store/useSessionSummaryStore";

export const MAX_SUMMARY_LENGTH = 930;
/** Time to prevent scheduling callback before ending call in seconds */
export const CALLBACK_CUTOFF = 2;

export const defaultAdditionalSummaryTimes: sessionSummaryTimesConfig = {
    autosend: 20 * 1000,
    manualCopy: 20 * 1000,
    maximum: 20 * 1000,
};

export const getTimeRemaining = (expirationTimestamp: number | undefined) => {
    return expirationTimestamp ? Math.max(expirationTimestamp - Date.now(), 0) : 0;
};

export function addSessionSummaryToTimeline(sessionId: string) {
    const { subject, summary, category, subcategory } = useSessionSummaryStore.getState();
    const caseNumber = useVerifiedCustomerStore.getState().getVerifiedCustomer(sessionId).customer
        ?.metadata?.caseNumber;
    let formattedSummary = "";
    if (caseNumber) {
        formattedSummary += `<p>Case #${caseNumber}</p>`;
    }
    if (subject) {
        formattedSummary += `<p>Subject: ${subject}</p>`;
    }
    if (summary) {
        formattedSummary += `${summary}`;
    }
    if (category) {
        formattedSummary += `<p>Category: ${category}</p>`;
    }
    if (subcategory) {
        formattedSummary += `<p>Subcategory: ${subcategory}</p>`;
    }
    if (formattedSummary) addSessionSummaryMessage(sessionId, { summary: formattedSummary, header: "Call summary" });
}
